import { css } from '@emotion/react';
import { scope } from '../../providers/GigerProvider/useTheme.js';
import { FlagSize } from './types/size.js';

const getFlagSizeStyles = (size, theme) => {
  switch (size) {
    case FlagSize.SMALL:
      return {
        height: 12,
        width: 18
      };
    case FlagSize.REGULAR:
      return {
        height: theme.spacing(7),
        width: theme.spacing(8)
      };
    case FlagSize.LARGE:
      return {
        height: theme.spacing(21),
        width: theme.spacing(22)
      };
    default:
      return {};
  }
};
const getFlagStyles = size => scope(theme => /*#__PURE__*/css({
  ...getFlagSizeStyles(size, theme)
}, process.env.NODE_ENV === "production" ? "" : ";label:getFlagStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZsYWdTdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0NZIiwiZmlsZSI6IkZsYWdTdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIENTU09iamVjdCwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgVGhlbWUgfSBmcm9tICdAc2hpcGVuZ2luZS9naWdlci10aGVtZSc7XG5cbmltcG9ydCB7IEZsYWdTaXplIH0gZnJvbSAnLi90eXBlcyc7XG5pbXBvcnQgeyBzY29wZSB9IGZyb20gJ0Bwcm92aWRlcnMvR2lnZXJQcm92aWRlci91c2VUaGVtZSc7XG5cbmNvbnN0IGdldEZsYWdTaXplU3R5bGVzID0gKHNpemU6IEZsYWdTaXplLCB0aGVtZTogVGhlbWUpOiBDU1NPYmplY3QgPT4ge1xuICAgIHN3aXRjaCAoc2l6ZSkge1xuICAgICAgICBjYXNlIEZsYWdTaXplLlNNQUxMOlxuICAgICAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDEyLFxuICAgICAgICAgICAgICAgIHdpZHRoOiAxOCxcbiAgICAgICAgICAgIH07XG4gICAgICAgIGNhc2UgRmxhZ1NpemUuUkVHVUxBUjpcbiAgICAgICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICAgICAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nKDcpLFxuICAgICAgICAgICAgICAgIHdpZHRoOiB0aGVtZS5zcGFjaW5nKDgpLFxuICAgICAgICAgICAgfTtcbiAgICAgICAgY2FzZSBGbGFnU2l6ZS5MQVJHRTpcbiAgICAgICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICAgICAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nKDIxKSxcbiAgICAgICAgICAgICAgICB3aWR0aDogdGhlbWUuc3BhY2luZygyMiksXG4gICAgICAgICAgICB9O1xuICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgcmV0dXJuIHt9O1xuICAgIH1cbn07XG5cbmV4cG9ydCBjb25zdCBnZXRGbGFnU3R5bGVzID0gKHNpemU6IEZsYWdTaXplKSA9PlxuICAgIHNjb3BlKFxuICAgICAgICAodGhlbWU6IFRoZW1lKTogU2VyaWFsaXplZFN0eWxlcyA9PlxuICAgICAgICAgICAgY3NzKHtcbiAgICAgICAgICAgICAgICAuLi5nZXRGbGFnU2l6ZVN0eWxlcyhzaXplLCB0aGVtZSksXG4gICAgICAgICAgICB9KVxuICAgICk7XG4iXX0= */"));

export { getFlagStyles };
//# sourceMappingURL=FlagStyles.js.map
